import { getSectionSplitByPage } from '../../../../../features/components/PdfGeneration/generatePdfReport/contentPreparation'
import { getSectionsScreenshots } from '../../../../../features/components/PdfGeneration/generatePdfReport'
import { cleanUpTemporaryPDFElements, processVideos } from '../../../../../helpers/pdf'
import { getSelectedPlatform } from '../../../../../helpers/handlePlatformSelection'

import { CARD_LIST_ITEM_CLASSNAME } from '../../../../../constants/pdf'
import { FACEBOOK_PLATFORM } from '../../../../../constants/selectLists/platformList'

const getReportPDFSections = async brandColor => {
  // takes DOM elements which will be taken as screenshots for PDF
  const reportSection = document.querySelector('#graphs-report')
  const lineItemsSection = getSectionSplitByPage('#line-items-table', 'li', 23)

  const selectedPlatform = getSelectedPlatform()

  const adsSection =
    selectedPlatform === FACEBOOK_PLATFORM
      ? getSectionSplitByPage('#ad-cards-list', `[class^="${CARD_LIST_ITEM_CLASSNAME}"]`, 5, newUl =>
          processVideos(newUl, brandColor)
        )
      : getSectionSplitByPage('#ad-cards-list', 'li', 23)

  const sections = [
    // line items could not fit one PDF page, and will be cut by library in unexpected places,
    // so we need to split it by pages manually
    ...lineItemsSection,
    ...adsSection,
    reportSection
  ]

  // create screenshots for each section
  const content = await getSectionsScreenshots(sections)
  // clean up all temporary elements with ".temporary-pdf-wrapper" class
  cleanUpTemporaryPDFElements()

  return content
}

export default getReportPDFSections
